import templateAdmin from '../../../../Template/config/components/adminView'

export default {
    ...templateAdmin
}


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/adminView/index.js